import { EditWithComparator } from 'poc/EditWithComparator'
import { renderCount } from 'poc/renderCount'
import React from 'react'
import {
  ArrayInput,
  FormDataConsumer,
  required,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TextInputProps,
} from 'react-admin'

const CustomTextInput: React.FC<TextInputProps> = (props) => {
  renderCount('CustomTextInput')
  return <TextInput {...props} />
}

const PocEdit: React.FC = () => (
  <EditWithComparator>
    {(comp) => (
      <SimpleForm>
        <TextInput disabled label="Id" source="id" />
        <TextInput source="title" validate={required()} />
        <ArrayInput source="highlights">
          <SimpleFormIterator>
            {comp({
              choice1: <TextInput label="choice1" source="item" />,
              choice2: (
                <FormDataConsumer>
                  {({ getSource }) => {
                    renderCount('FormDataConsumer')
                    return (
                      <TextInput label="choice2" source={getSource!('item')} />
                    )
                  }}
                </FormDataConsumer>
              ),
              choice3: <CustomTextInput label="choice3" source="item" />,
            })}
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    )}
  </EditWithComparator>
)

export default PocEdit
